// CORE
import React from "react";
import { Link } from "react-router-dom";

// COMPONENTS
import NotificationPriority from "../shared/NotificationPriority";
import NotificationReadStatus from "../shared/NotificationReadStatus";
import NotificationTime from "../shared/NotificationTime";

// STYLES
import styles from "./styles/style.module.scss";

function GeneralTemplate({ notification, index, icon, link }) {
    return (
        <Link className={styles["notification-template"]} to={link} key={index}>
            <div
                className="notification-wrapper"
                data-notification-read={notification?.read}
            >
                <div className="data-container">
                    <div
                        className="image"
                        style={{ backgroundColor: "#0A3370" }}
                    >
                        <img src={icon} alt="" />
                    </div>
                    <div className="info">
                        <div>
                            <h5>
                                {notification?.title}
                                <NotificationPriority
                                    notification={notification}
                                />
                            </h5>

                            <div className="footer">
                                <span className="date">
                                    <NotificationTime
                                        notification={notification}
                                    />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <NotificationReadStatus notification={notification} />
            </div>
        </Link>
    );
}

export default GeneralTemplate;
